export default __webpack_public_path__ + "d599e7de933531ffe00b2673a0495016.svg";